module.exports = __webpack_public_path__ + "3274e55377051c411b495c649a146505.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/5.jpg
// module id = 290
// module chunks = 0